/* sections/results.liquid */

export class ResultsSection extends HTMLElement {
  swiper = null;
  resizeTimeout = null;

  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
  }

  get isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  get selector() {
    return `#results-${this.sectionId}`;
  }

  connectedCallback() {
    this.handleResize();

    this.resizeObserver = new ResizeObserver(() => this.handleResize());
    this.resizeObserver.observe(this);

    this.handleWindowResize = () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.handleResize(), 100);
    };
    window.addEventListener('resize', this.handleWindowResize);
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.handleWindowResize);
    clearTimeout(this.resizeTimeout);
  }

  handleResize() {
    if (this.isMobile) {
      if (!this.swiper) this.init();
    } else if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  init() {
    if (!this.isMobile || !this.sectionId || !window.Swiper) return;

    const swiperEl = document.querySelector(this.selector);
    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

    const isCustomWidth = this.hasAttribute('data-custom-width');

    try {
      this.swiper = new Swiper(this.selector, {
        slidesPerView: isCustomWidth ? 'auto' : 1,
        spaceBetween: 16,
        pagination: {
          el: `${this.selector} .results__pagination`,
          clickable: true,
        },
        loop: false,
        watchOverflow: true,
        breakpoints: {
          750: { enabled: false },
        },
      });
    } catch (error) {
      console.error('Results: Error initializing Swiper', error);
    }
  }
}

if (!customElements.get('results-section')) {
  customElements.define('results-section', ResultsSection);
}
